import { withTopbarProps } from '@jusbrasil/topbar'
import { withUserSession } from '@jusbrasil-web/shared-user-session'
import { getFirstQueryParam } from '@jusbrasil-web/shared-utils-url'
import { GetServerSideProps } from 'next'

import { AuthLayout, EmailValidationAccount } from '../../../components'
import { ROUTES } from '../../../constants'

export interface VerifyAppEmailPageProps {
  email: string
  token?: string
  nextUrl?: string
}

export function VerifyAppEmailPage({ email }: VerifyAppEmailPageProps) {
  return (
    <AuthLayout>
      <EmailValidationAccount email={email} />
    </AuthLayout>
  )
}

const getServerSideProps: GetServerSideProps = async (ctx) => {
  const email = getFirstQueryParam(ctx.query.email)

  if (!email) {
    return {
      redirect: {
        destination: ROUTES.SIGN_UP.BEGIN,
        permanent: false,
      },
    }
  }

  return {
    props: {
      ...withTopbarProps(ctx),
      ...withUserSession(ctx),
      email,
      token: (ctx.params?.token as string | undefined) || null,
      nextUrl: getFirstQueryParam(ctx.query.next_url) || null,
    },
  }
}

export const VerifyAppEmailPageExports = {
  getServerSideProps,
}
